// @flow
export { default } from './BrandTags';



// WEBPACK FOOTER //
// ./src/components/brand/BrandTags/index.js